<template>
  <div class="xiangmu">
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../assets/images/cpgl.png" class="steps step1" v-if="status==1">
      <img src="../../assets/images/cpgl1.png" class="steps step2" v-if="status==2">
      <div class="stepbtn" @click="nextStep(status)">
        {{ status == 1 ? "下一步" : status == 2 ? "我知道了" : "我知道了" }}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <!--<div class="h-crumbOut">-->
    <!--	<div class="h-crumbs">-->
    <!--		<el-breadcrumb separator="|">-->
    <!--			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
    <!--			<el-breadcrumb-item>产品管理</el-breadcrumb-item>-->
    <!--		</el-breadcrumb>-->
    <!--	</div>-->
    <!--</div>-->
    <Breadtabsheader/>
    <div class="h-piece h-mrt30">
      <div class="h-formBox">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="产品型号">
              <el-input v-model="q.materialDescrition" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="产品编号">
              <el-input v-model="q.materialCode" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="产品大类">
              <brselectlazy style="width: 100%;" category="product_level" :v="q.hid" v-model="q.hid" :clearable="true"/>
            </el-form-item>
            <el-form-item label="产品属性">
              <el-select v-model="q.protype" placeholder="请选择" :clearable="true">
                <el-option label="自产" value="自产"></el-option>
                <el-option label="OEM" value="OEM"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="服务类型">
                  <el-select v-model="q.serviceProductsType" placeholder="请选择">
                    <el-option v-for="item in fuwuleixing" :key="item.value"
                               :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否医疗器械">
                  <el-select v-model="q.isMedicalDevice" placeholder="请选择" :clearable="true">
                      <el-option label="是" value="是"></el-option>
                      <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="物料描述">
                    <el-input v-model="q.productDetail" placeholder=""></el-input>
                </el-form-item>
              </div>
            </div>
          </el-collapse-transition>
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <!--<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.9rem;"-->
            <!--		   @click="toNew">新建虚拟物料-->
            <!--</el-button>-->
          </div>
        </div>
      </div>
    </div>
    <div class="h-table h-mrt30" v-if="clickActive==1">
      <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData2"
          style="width: 100%"
          :border="true"
          max-height="440"
      >
        <el-table-column
            type="selection"
            width="45"
            :label="all"
        >
        </el-table-column>
        <el-table-column
            fixed
            type="index"
            label="#"
            width="40">
        </el-table-column>
        <el-table-column
            prop="levelname"
            label="产品大类"
            width="100"
            :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
            prop="materialCode"
            label="产品编号"
            width="120"
            :show-overflow-tooltip="true"
        >

        </el-table-column>

        <!--                <el-table-column-->
        <!--                        prop="groupname"-->
        <!--                        label="物料组"-->
        <!--						:show-overflow-tooltip="true"-->
        <!--                >-->

        <!--                </el-table-column>-->
        <el-table-column
            prop="materialDescrition"
            label="产品型号"
            min-width="180"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{ scope.row.materialDescrition }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="oemDesc"
            label="规格型号"
            width="120"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="protype"
            label="产品属性"
            width="100"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="chainStatus"
            label="产品状态"
            width="130"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="productHierarchy"
            label="产品层次"
            width="140"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="Tax"
            label="税分类"
            width="120"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
          <dictname category="YLMtlTaxType" :v="scope.row.Tax"></dictname>
          </template>
        </el-table-column>
        <el-table-column
            prop="mtlGroupCode"
            label="物料组编码"
            width="120"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="mtlGroupName"
            label="物料组描述"
            width="120"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="spbmjcmtlgroupname"
            label="开票名称"
            width="240"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="serviceProductsType"
            label="服务类型"
            min-width="150"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="eanUpc1"
            label="生产企业名称"
            min-width="150"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="isMedicalDevice"
            label="是否医疗器械"
            min-width="150"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="ean"
            label="注册证有效期"
            min-width="150"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="placeOrigin"
            label="供货者"
            min-width="150"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="created"
            label="创建时间"
            min-width="150"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="productDetail"
            label="物料描述"
            min-width="150"
            :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
            label="操作"
            fixed="right"
            width="120"
        >
          <template slot-scope="scope">
            <div style="text-align: left;">
              <el-button
                  v-if="scope.row.statusflag!=0"
                  type="text"
                  size="small"
                  class="h-tableLink h-btn" @click="todetail(scope.row)">
                查看
              </el-button>

              <el-button
                  v-else
                  type="text"
                  size="small"
                  class="h-tableLink h-btn" @click="xiugai(scope.row)">
                修改
              </el-button>

              <el-button
                  v-if="(scope.row.zhuangtaidaima==1||scope.row.zhuangtaidaima==0)&&scope.row.zhuangtaidaima!=null&&scope.row.zhuangtaidaima!=''"
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="chakanjindu(scope.row)">跟踪
              </el-button>
              <el-button
                  v-if="scope.row.fictitious=='mdm产品'"
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="xiugai3Q(scope.row)">修改
              </el-button>
            </div>
            <!-- <div class="l-operationBox">
              <span class="l-operationlist br-operation-look" v-if="scope.row.statusflag!=0" title="查看" @click="todetail(scope.row)"></span>
              <span class="l-operationlist br-operation-xg" v-else title="修改" @click="xiugai(scope.row)"></span>
              <span class="l-operationlist br-operation-spgz" v-if="(scope.row.zhuangtaidaima==1||scope.row.zhuangtaidaima==0)&&scope.row.zhuangtaidaima!=null&&scope.row.zhuangtaidaima!=''" title="跟踪审批" @click="chakanjindu(scope.row)"></span>
            </div> -->

          </template>
        </el-table-column>
      </el-table>
      <div class="h-tableB h-mrt30">
        <div class="h-tableBL">
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                     style="margin-left:-20px;" @click="outexcel">批量导出
          </el-button>
          <!--<el-button class="h-btn h-formBtn h-bgblueQ" @click="addcompd" v-auth="'probd'">添加产品比对</el-button>-->
        </div>

        <div class="h-pagination2">
          <pagination :page="q" @query="query"/>
        </div>
        <!--					<div class="h-pagination2">-->
        <!--						<span class="h-pagiLabel">显示数量:</span>-->
        <!--						<el-pagination-->
        <!--						  @size-change="handleSizeChange"-->
        <!--						  @current-change="handleCurrentChange"-->
        <!--						  :current-page="4"-->
        <!--						  :page-sizes="[10, 20, 30, 40]"-->
        <!--						  :page-size="10"-->
        <!--						  layout="sizes, prev, pager, next,jumper"-->
        <!--						  :total="400">-->
        <!--						</el-pagination>-->
        <!--					</div>-->
      </div>
    </div>

    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>

  </div>
</template>
<script>
import ss from '../../api/SystemService'

export default {
  name: "productManage",
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      // 新手引导页
      showOrhide: false,
      status: 1,
      checked: true,
      toshow: "productManage",

      instid: '',

      showhistory: false,

      chanpinzhuangtai: [{
        value: 1,
        label: '虚拟物料'
      }, {
        value: 0,
        label: '真实物料'
      }],
      fuwuleixing: [{
        value: '3Q服务类',
        label: '3Q服务类'
      }, {
        value: '售后增值服务',
        label: '售后增值服务'
      }, {
        value: '其他',
        label: '其他'
      }],

      jindu: [{
        value: 1,
        label: '提交'
      }, {
        value: 0,
        label: '暂存'
      }],

      q: {
        status: null,
        hid: null,
        fictitious: null,
        materialGroupCode: null,
        materialDescrition: null,
        serviceProductsType: null,
        isMedicalDevice:null,
        materialCode: null,
        protype:null,
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      wuliaozu: [],
      chanpindalei: [],
      //表单
      all: '全部',
      // formInline: {
      //     dalei: '',
      //     status: '',
      //     group: '',
      //     type: '',
      // },
      //表格
      multipleSelection: [],
      tableData2: [],
      clickActive: 1
    }
  },

  //加载页面默认执行
  created() {
    this.showzhezhao()
    //默认首次交互
    this.gettableels();
  },

  //监听
  watch: {},

  methods: {
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    showzhezhao() {
      ss.salesList.toshow(this.toshow).then(rd => {
        console.log(rd)
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    },
    chakanjindu(q) {

      var material = {

        mdmMaterialInfoCopy: {

          id: q.xuniwuliao,

        }

      }

      console.log(material, 'material')

      ss.chanpin.chaxunwuliao(material).then(rd => {

        console.log(rd, 'rd')

        this.instid = rd.obj.instid;
        this.showhistory = true;

      })


    },


    resetData() {

      this.q.hid = null;
      this.q.status = null;
      this.q.materialGroupCode = null;
      this.q.materialDescrition = null;
      this.q.materialCode = null;
      this.q.fictitious = null;
      this.q.serviceProductsType = null;
      this.q.pageSize = 10;
      this.q.pageNo = 1;

    },

    handleCurrentChange() {

    },
    handleSizeChange() {

    },

    //创建新物料
    toNew() {
      this.$router.push({path: '/chanp/productCreate'});
    },

    //详情
    todetail(q) {

      this.$router.push({path: '/chanp/productDetail', query: q});
    },


    //查询翻页
    query() {
      this.q.ids = [];
      this.q.rowids = [];
      //this.q.protype = 'OEM_OR_自产'目的是在后端过滤protype是""的
      if(this.q.protype == null && this.q.protype == ''){
        this.q.protype = 'OEM_OR_自产';
      }
      ss.chanpin.selectPage(this.q).then(rd => {
        console.log('看看走没走查询', rd.records)
        this.tableData2 = [],
            this.q.total = rd.total;
        for (var t in rd.records) {
            console.log(rd.records[t]);
            var ousa = ((rd.records[t].fictitious == null || rd.records[t].fictitious == '') && rd.records[t].fictitious != 0) ? (rd.records[t].rowId != null && rd.records[t].rowId != '') ? 'mdm产品' : '' : rd.records[t].fictitious == 0 ? '真实产品' : '虚拟产品';
            console.log(ousa, '啥')
            if (rd.records[t].rowId != null) {
              ousa = 'mdm产品';
            }
            var ss = {
              productHierarchy: rd.records[t].productHierarchy,
              levelname: rd.records[t].levelname || '',//产品大类
              materialGroupCode: rd.records[t].materialGroupCode,//物料组
              materialDescrition: rd.records[t].materialDescrition,//物料型号
              oemType: rd.records[t].oemType || '',//业务类型  SH或者HK。SH为上海OEM，HK为香港OEM    ****只有从我们这里保存的产品才有****
              fictitious: ousa,//状态  0 真实产品   1 虚拟产品
              hid: rd.records[t].hid,
              rowId: rd.records[t].rowId,
              zhuangtaidaima: rd.records[t].fictitious,
              materialCode: rd.records[t].materialCode,//含虚拟物料的表的编码
              rowId: rd.records[t].rowId,//mdm取数的表的主键
              status: rd.records[t].status == 0 ? '暂存' : rd.records[t].status == 1 ? '提交' : '',//mdm取数的表的主键
              xuniwuliao: rd.records[t].xuniwuliao,//虚拟物料编码
              statusflag: rd.records[t].status,//暂存提交的fiag
              groupname: rd.records[t].groupname,//物料组名
              serviceProductsType: rd.records[t].serviceProductsType,
              eanUpc1: rd.records[t].eanUpc1,
              isMedicalDevice: rd.records[t].isMedicalDevice,
              ean: rd.records[t].ean,
              placeOrigin: rd.records[t].placeOrigin,
              Tax: rd.records[t].tax,
              protype: rd.records[t].protype,
              chainStatus: rd.records[t].chainStatus,
              mtlGroupCode: rd.records[t].mtlGroupCode,
              mtlGroupName: rd.records[t].mtlGroupName,
              oemDesc: rd.records[t].oemDesc,
              spbmjcmtlgroupname: rd.records[t].spbmjcmtlgroupname,
              created: rd.records[t].created,
              productDetail: rd.records[t].productDetail
            }
            this.tableData2.push(ss);
            if(this.q.protype == 'OEM_OR_自产'){
              this.q.protype = null;
            }
        }
      })
    },
    //加载配置项
    gettableels() {
      this.query();
    },
    handleFilter() {
      this.q.pageNo = 1;
      this.query();
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    //导表
    outexcel() {
      var idas = [];
      var rowIdbs = [];
      for (var d in this.multipleSelection) {
        idas.push(this.multipleSelection[d].materialCode);
        rowIdbs.push(this.multipleSelection[d].rowId);
      }
      this.q.ids = idas;
      this.q.rowids = rowIdbs;
      console.log('导表参数', this.q);
      ss.chanpin.downloadExcelNew(this.q);
    },
    //修改内容
    xiugai(q) {
      this.$router.push({path: '/chanp/productCreate', query: q});
    },
    //修改内容
    xiugai3Q(q) {
      this.$router.push({path: '/chanp/productCreate3Q', query: q});
    },
    // //点击查看详情
    // chakan(item) {
    //
    // 	console.log('行', item)
    //
    // 	this.$router.push({ path:'/jingpin/detail' , query: {id: item.id}});
    //
    // }
    closeIt() {
      this.showOrhide = false;
      if (this.checked) {
        sessionStorage.productManage = '3';
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      }
    },
    nextStep(i) {
      if (this.status == 1) {
        this.status = 2;
      } else if (this.status == 2) {
        if (this.checked) {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }
      }
    },
    addcompd() {
      if (this.multipleSelection.length == 0) {
        this.$msg.msge("请至少选择一条数据！");
      } else {
        // this.$router.push({name:'/chanp/comparisonDetails',params:{datalist:this.multipleSelection}})
        var proli = [];
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].fictitious != "mdm产品") {
            this.$msg.msge("请选择mdm产品！");
            return false;
          }
          proli.push(this.multipleSelection[i].materialCode);
        }
        JSON.stringify(proli)
        sessionStorage.setItem('duibiproli', proli);
        this.$router.push('/chanp/comparisonDetails');
      }
    }
  },
  mounted() {

  },
}
</script>
<style scoped>
.xiangmu > .h-piece, .h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 3rem !important;
}
</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
}

.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785E7;
  z-index: 2;
}

.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;

  .leaderbg {
    width: 100%;
    height: 100%;
  }

  .steps {
    position: absolute;
    z-index: 1;
  }

  .step1 {
    top: 2.3rem;
    left: 8.25rem;
    width: 2.1rem;
    height: 1.8rem;
  }

  .step2 {
    top: 3.05rem;
    right: 1.1rem;
    width: 2.8rem;
    height: 1.9rem;
  }

  .step3 {
    top: 4.2rem;
    left: 2.7rem;
    width: 13.5rem;
    height: 2rem;
  }

  .step4 {
    top: 6.2rem;
    left: 11rem;
    width: 2rem;
    height: 1.5rem;
  }

  .stepbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #FFFFFF;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.65rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .closeIt {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
  }
}
</style>
